module.exports = __webpack_public_path__ + "img/a-back.4eefd488.png";